import { LitElement, html, css } from '@hh/global.js';

class HHRadioWrapper extends LitElement {
  static properties = {
    disabled: {
      type: Boolean,
      reflect: true,
    },
    toggleType: {
      type: Boolean,
    }
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  firstUpdated() {
    this.disabled = this.input.disabled
  }

  get input() {
    const slot = this.shadowRoot?.querySelector(`slot[name='input']`)
    return slot?.assignedNodes()[0] ?? null
  }

  render() {
    return html`
      <slot name="input"></slot>
      <slot name="label"></slot>
    `
  }

  static styles = css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    :host {
      display: flex;
      align-items: var(--hh-align-items, flex-start);
      column-gap: 0.8rem;
      color: var(--hh-color, #646464);
    }

    ::slotted(input) {
      appearance: none;
      touch-action: none;
      margin: 0;
      width: var(--hh-width, 2.4rem);
      height: var(--hh-height, 2.4rem);
      border: 1px solid var(--hh-color, #646464);
      border-radius: var(--hh-border-radius, 50%);
      position: relative;
      cursor: pointer;
      align-self: flex-start;
    }

    ::slotted(input)::before {
      content: '';
      pointer-events: none;
      width: calc(var(--hh-width, 2.4rem) / 2);
      height: calc(var(--hh-height, 2.4rem) / 2);
      border-radius: var(--hh-border-radius, 50%);
      background-color: var(--hh-color, #646464);
      scale: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    ::slotted(input:checked)::before {
      scale: 1;
    }

    ::slotted(input:focus) {
      border: 1px solid var(--hh-color, #646464) !important;
    }

    ::slotted(input:disabled) {
      background-color: var(--hh-color-input-disabled);
      border: 1px solid var(--hh-color-light);
      cursor: default;
    }

    ::slotted(label) {
      cursor: pointer;
      max-width: var(--hh-label-max-width, 21rem);
    }

    :host([disabled]) ::slotted(label) {
      cursor: default;
    }
  `
}

if (!customElements.get('hh-radio-wrapper')) {
  customElements.define('hh-radio-wrapper', HHRadioWrapper);
}
